class AveyFooterTrustpilot extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.load();
    }, { rootMargin: '300px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() { this.observer?.disconnect(); }

  load() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    const source = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    const render = () => this.querySelectorAll('.trustpilot-widget').forEach((widget) => window.Trustpilot?.loadFromElement(widget, true));
    if (window.Trustpilot) return render();

    let script = document.querySelector(`script[src="${source}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = source;
      script.async = true;
      document.head.append(script);
    }
    script.addEventListener('load', render, { once: true });
  }
}

if (!customElements.get('avey-footer-trustpilot')) customElements.define('avey-footer-trustpilot', AveyFooterTrustpilot);
